var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-collapse-item',{attrs:{"name":_vm.name,"title":_vm.title,"disabled":_vm.fdisabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }